import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const nurseryMidYearAdmission: BlogMetaData = {
  title: '保育園に途中入園はできる？入りやすい時期と空きの探し方【認可外という選択肢】',
  description:
    '保育園の途中入園は空きがあれば可能です。入りやすい時期の目安、空き状況の探し方、認可・認可外それぞれの申込方法とメリット・デメリットをモンテ歴20年以上の園長が解説します。',
  thumbnailUrl: '/img/blog-nursery-mid-year-admission.webp',
  filePath: buildBlogFilePath('nursery-mid-year-admission'),
  category: BLOG_CATEGORY.NURSERY,
};
